import DOMPurify from 'dompurify';
import { embedYouTubeInHTML } from '../../utils/youtube';

export const noticeDetailPath = (slug) =>
  /^\d+$/.test(slug) ? `/notices/${slug}` : `/notices/by-slug/${encodeURIComponent(slug)}`;

export function noticeHtml(content) {
  const normalized = String(content || '<p></p>')
    .replace(/<p>(?:\s|&nbsp;|<br\s*\/?\s*>)*<\/p>/gi, '<div class="postpop-editor-spacer"></div>')
    .replace(/<p>\s*(<img\b[^>]*>)\s*<\/p>/gi, '<div class="postpop-editor-image">$1</div>');
  const doc = new DOMParser().parseFromString(
    DOMPurify.sanitize(embedYouTubeInHTML(normalized), {
      ADD_TAGS: ['iframe'],
      ADD_ATTR: ['allowfullscreen'],
    }),
    'text/html',
  );
  doc.body.querySelectorAll('[style]').forEach((node) => {
    // Preserve editorial alignment/emphasis, not fixed fonts, offsets or colors
    // that can override the app typography or make dark mode unreadable.
    const keep = ['text-align', 'font-weight', 'font-style', 'text-decoration'];
    const values = keep.map((key) => [key, node.style.getPropertyValue(key)]);
    node.removeAttribute('style');
    values.forEach(([key, value]) => {
      if (value) node.style.setProperty(key, value);
    });
  });
  doc.body.querySelectorAll('font').forEach((node) => {
    node.removeAttribute('color');
    node.removeAttribute('size');
    node.removeAttribute('face');
  });
  doc.body.querySelectorAll('iframe').forEach((node) => {
    if (
      !/^https:\/\/www\.youtube\.com\/embed\/[\w-]+(?:[?#]|$)/.test(node.getAttribute('src') || '')
    )
      node.remove();
    else {
      node.setAttribute('title', 'YouTube');
      node.setAttribute('loading', 'lazy');
    }
  });
  doc.body.querySelectorAll('a').forEach((node) => node.setAttribute('rel', 'noopener noreferrer'));
  doc.body.querySelectorAll('img').forEach((node) => {
    node.setAttribute('loading', 'lazy');
    node.setAttribute('alt', node.getAttribute('alt') || '');
  });
  return doc.body.innerHTML;
}
